export default __webpack_public_path__ + "static/media/map.55ed0f12.png";